import React, { useMemo } from "react";
import styles from '../styles/header.module.scss'
import { useAssetImage } from "@/platforms/utils";
import SpriteContainer from "@/wmCompoments/spriteContainer";
import Button from "@/wmCompoments/button";
import { useUserInfo } from "@/api/request";
import { useModal } from "@/modals/modalContext";
import { useTranslation } from "react-i18next";


const Header = () => {
    const bgImage = useAssetImage('accountManagermentHeaderBG')

    const { data: userInfo } = useUserInfo()
    const { openModal } = useModal()
    const { t } = useTranslation('accountManagement')
    const { data: user} =  useUserInfo()

    const list = useMemo(() => {
        const hasRealName = !!user?.realName
        const hasPhone = !!user?.phone
        return [
            {
                icon: 'icon_phone',
                text: hasPhone ? user?.phone : t('phoneVerification'),
                buttonText: hasPhone ? '' : t('modify'),
                hide: hasPhone,
                onClick: () => {
                    openModal('bindPhone')
                }
            },
            {
                icon: 'icon_password',
                text: hasRealName ? user?.realName : t('setRealName'),
                buttonText: t('set'),
                hide: hasRealName,
                onClick: () => {
                    openModal('bindName')
                }
            },
            {
                icon: 'icon_password',
                text: t('modifyLoginPassword'),
                buttonText: t('modify'),
                onClick: () => {
                    if (userInfo?.bindPhone){
                        openModal('phoneVerification')
                    } else {
                        openModal('changePassword')
                    }
                    
                }
            },
            {
                icon: 'icon_password',
                text: t('setFundPassword'),
                buttonText: t('set'),
                onClick: () => {

                }
            }
        ]
    }, [user])

    return <div className={styles.warpper}>
        <div className={styles.bgWarpper}>
            <img src={bgImage} />

            <div className={styles.titleWarpper}>
                <div>
                    {t('okHashSecurityCenter')}
                </div>
                <div>
                    {t('escortForAccountSecurity')}
                </div>
            </div>
        </div>

        <div className={styles.bottomWarpper}>
            <div>{t('accountSecurity')}</div>
            <div className={styles.grid}>
                {
                    list?.map((v, index) => {
                        return <div className={styles.item} key={index}>
                            <SpriteContainer name={v.icon} className={styles.icon} />
                            <span className={styles.text}>{v.text}</span>
                            {!v.hide && <Button type={'green'} className={styles.button} onClick={v.onClick} >{v.buttonText}</Button>}
                        </div>
                    })
                }
            </div>
        </div>
    </div>
}

export default Header